module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/1@2x_f89539852cf0e50b2482e91820e4a9e4.png";